/**
 * <modal-dialog> — moderne accessible modal met native <dialog> API.
 *
 * Features:
 *  - Native <dialog> element (Baseline 2022, alle browsers 2024+)
 *  - Backdrop click-to-close, ESC-to-close — gratis via de browser
 *  - Focus trap + restore — gratis
 *  - Open-triggers: elk element met [data-open-dialog="<dialog-id>"]
 *  - Reduced-motion friendly: geen animaties bij prefers-reduced-motion
 *
 * Usage:
 *   <button data-open-dialog="test-conditions">Lees meer</button>
 *   <modal-dialog id="test-conditions" label="Test condities">
 *     <h2 slot="heading">Test Condities</h2>
 *     <p>...</p>
 *   </modal-dialog>
 */
if (!window.__ModalDialogLoaded) {
window.__ModalDialogLoaded = true;
class ModalDialog extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.setAttribute('role', 'presentation');

    const dialogId = this.id;
    const labelText = this.getAttribute('label') || this.querySelector('[slot="heading"]')?.textContent || 'Dialoog';

    // Bouw native <dialog> rondom bestaande inhoud
    const dialog = document.createElement('dialog');
    dialog.className = 'modal-dialog__native';
    dialog.setAttribute('aria-label', labelText);

    // Verplaats alle kinderen in de <dialog>
    const inner = document.createElement('div');
    inner.className = 'modal-dialog__inner';
    while (this.firstChild) inner.appendChild(this.firstChild);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'modal-dialog__close';
    closeBtn.setAttribute('aria-label', 'Sluiten');
    closeBtn.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    closeBtn.addEventListener('click', () => dialog.close());

    dialog.appendChild(closeBtn);
    dialog.appendChild(inner);

    // Click-op-backdrop sluit (native gedrag voor showModal())
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });

    this.appendChild(dialog);
    this._dialog = dialog;

    // Registreer triggers ergens op de page
    if (dialogId) {
      document.querySelectorAll(`[data-open-dialog="${dialogId}"]`).forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });
    }
  }

  open() {
    this._dialog?.showModal();
  }

  close() {
    this._dialog?.close();
  }
}

if (!customElements.get('modal-dialog')) {
  customElements.define('modal-dialog', ModalDialog);
}
}
